import {useState, useEffect} from 'react';
import { fetch as authFetch } from '../Helpers/auth';

const useSaveItem = ({url, method="POST", cb=()=>null}) => {
  const [isSaving, setIsSaving] = useState(false)
  const [isSaved, setIsSaved] = useState(false)
  const [error, setError] = useState(null)
  const [data, saveData] = useState(undefined)
  const [answer, setAnswer] = useState(undefined)
  useEffect(() => {
    if (data) {
      setIsSaving(true);    
      authFetch(url, {
        method,
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }).then(res => res.json())
        .then(res => {
          setIsSaving(false);
          setIsSaved(true);
          setAnswer(res);
          saveData(undefined);
          cb();
      }).catch(setError)
    }
  }, [data])
  return {
    isSaving,
    isSaved,
    saveData,
    answer,
    error,
    data,
  }
}

export default useSaveItem
